<template>
  <v-container fluid class="background py-10">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="partnerships_title my-3">
            {{ partnerships.title }}
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex">
        <v-col
          v-for="(partner, i) in partners"
          :key="i"
          class="ma-auto clicable"
          md="4"
          sm="6"
          cols="6"
          @click="redirectToPartner(partner.site)"
        >
          <v-img
            alt="partnership image"
            class="shrink mx-auto"
            contain
            :src="partner.image"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="partnerships_title mb-3 mt-6">
            {{ acordos.title }}
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex">
        <v-col
          v-for="(partner, i) in acordosList"
          :key="i"
          class="clicable"
          md="4"
          sm="6"
          cols="6"
          @click="redirectToPartner(partner.site)"
        >
          <v-img
            alt="partnership image"
            class="shrink mx-auto"
            contain
            :src="partner.image"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import lang from "../../lang/pt.json";

import cardioon from "../../assets/png/logoh.png";
import sams from "../../assets/png/saude_sams_quadros.png";
import unilabs from "../../assets/svg/logo-unilabs.svg";

export default {
  name: "Partnerships",

  data: () => ({
    acordos: lang.home.acordos,
    acordosList: [
      {
        site: "https://www.snqtb.pt/",
        image: sams,
      },
    ],
    partnerships: lang.home.partnerships,
    partners: [
      {
        site: "https://www.unilabs.pt/",
        image: unilabs,
      },
      {
        site: "https://home.cardio-on.com",
        image: cardioon,
      },
    ],
  }),

  methods: {
    redirectToPartner(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.background {
  background-color: white;
}

.partnerships_title {
  color: map-get($theme-colors, "dark-blue");
  font-family: nexa_bold;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 29px;
}

.clicable {
  cursor: pointer;
}

.clicable:hover {
  transition: transform 0.2s;
  transform: scale(1.1);
}
</style>
